var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiorbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 20,
    viewBox: "0 0 138 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8408 0.466797H33.093C37.0303 0.466797 39.4731 2.25537 39.4731 5.211C39.4731 7.3524 38.196 8.95369 36.1336 9.43951C38.6851 9.87376 40.204 11.6895 40.204 14.238C40.204 17.4922 37.571 19.4436 33.2833 19.4436H24.8408V0.466797ZM32.93 8.33218C34.9652 8.33218 36.188 7.38225 36.188 5.78366C36.188 4.18508 34.9652 3.31656 32.93 3.31656H28.0444V8.33218H32.93ZM32.93 16.602C35.4272 16.602 36.9189 15.6249 36.9189 13.8363C36.9189 12.1563 35.4272 11.1521 32.93 11.1521H28.0444V16.602H32.93Z",
    fill: "#1C1460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7339 0.360962C44.7664 0.360962 45.5517 1.14805 45.5517 2.2581C45.5517 3.34373 44.7637 4.1281 43.7339 4.1281C42.704 4.1281 41.916 3.34102 41.916 2.2581C41.9133 1.14805 42.7013 0.360962 43.7339 0.360962ZM42.185 6.38078H45.28V19.449H42.185V6.38078Z",
    fill: "#1C1460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4535 4.91516C58.9043 4.91516 61.972 7.87079 61.972 12.235C61.972 16.5721 58.9043 19.5549 54.4535 19.5549C49.9755 19.5549 46.9077 16.5721 46.9077 12.235C46.9077 7.87079 49.9755 4.91516 54.4535 4.91516ZM54.4535 16.9521C57.0321 16.9521 58.8499 15.0549 58.8499 12.2622C58.8499 9.49652 57.0321 7.59938 54.4535 7.59938C51.8476 7.59938 50.0298 9.49652 50.0298 12.2622C50.0298 15.0549 51.8476 16.9521 54.4535 16.9521Z",
    fill: "#1C1460"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5996 5.02373H66.7217V7.89792C67.6999 5.94651 69.4362 4.91516 71.716 4.91516V7.89792C68.8113 7.73508 66.9663 9.44224 66.7217 11.9093V19.4463H63.5996V5.02373Z",
    fill: "#1C1460"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5361 0.466797H82.2775C86.4566 0.466797 89.0651 2.28251 89.0651 5.211C89.0651 7.27098 87.8152 8.87228 85.78 9.38524C88.2228 9.84664 89.7417 11.6895 89.7417 14.1837C89.7417 17.4379 87 19.4436 82.5763 19.4436H73.5361V0.466797ZM82.0601 8.11504C83.6605 8.11504 84.6659 7.32797 84.6659 6.00079C84.6659 4.70075 83.6605 3.96795 82.0601 3.96795H77.8266V8.11776H82.0601V8.11504ZM82.0601 15.9506C84.0953 15.9506 85.318 15.1092 85.318 13.6463C85.318 12.2649 84.0953 11.4235 82.0601 11.4235H77.8266V15.9506H82.0601Z",
    fill: "#1C1460"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.663 10.6908H100.682V10.4194C100.682 8.87505 99.6492 7.97939 97.6412 7.97939C96.3396 7.97939 94.818 8.41365 93.2991 9.25501L91.9948 6.38082C94.1659 5.29519 96.0407 4.70081 98.5922 4.70081C102.502 4.70081 104.755 6.65221 104.782 9.93353L104.809 19.4491H100.712V17.7419C99.7335 18.9633 98.1602 19.6391 96.125 19.6391C93.0029 19.6391 91.1035 17.7419 91.1035 15.0848C91.0981 12.3436 93.079 10.7179 96.663 10.6908ZM97.2879 16.6536C99.0514 16.6536 100.437 15.7037 100.682 14.4579V13.1578H97.3966C95.7962 13.1578 95.0082 13.6464 95.0082 14.8107C95.0082 15.9235 95.875 16.6536 97.2879 16.6536Z",
    fill: "#1C1460"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.787 4.8609H110.966V7.40941C111.999 5.5937 113.735 4.7252 116.015 4.69806C119.273 4.69806 121.362 6.86661 121.362 10.2836V19.449H117.183V11.5022C117.183 9.65939 116.096 8.51948 114.306 8.51948C112.216 8.54662 110.966 10.1181 110.966 12.2622V19.4463H106.787V4.8609Z",
    fill: "#1C1460"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.479 0.466797H127.658V10.3894L133.006 4.88531H137.755L132.408 10.498L138 19.4463H133.06L129.53 13.5079L127.658 15.4865V19.4436H123.479V0.466797Z",
    fill: "#1C1460"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49406 19.9973H0V9.6268C7.27131 9.15998 8.49406 15.6005 8.49406 19.9973Z",
    fill: "url(#paint0_linear_692_3274)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.04871V0H11.3553C11.7629 0 12.1623 0.0434255 12.5482 0.127562C12.4531 0.388113 12.3607 0.659514 12.271 0.944492C9.34999 10.0638 1.72544 9.33911 0 9.04871Z",
    fill: "url(#paint1_linear_692_3274)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4092 11.7872C16.8004 12.5553 17.0205 13.4211 17.0205 14.3384C17.0205 17.4515 13.7435 20 10.6269 20H10.3579C3.47785 6.3265 15.1511 2.45351 15.8548 2.23639C16.5885 3.18903 17.0205 4.37779 17.0205 5.66426C17.0205 7.31171 16.1021 8.80173 14.7734 9.83851C15.4554 10.3542 16.0179 11.0218 16.4092 11.7872Z",
    fill: "url(#paint2_linear_692_3274)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_3274",
    x1: 15.7008,
    y1: -0.528529,
    x2: -0.625501,
    y2: 21.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E31B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1460"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_692_3274",
    x1: 10.367,
    y1: -4.50172,
    x2: -5.95933,
    y2: 17.4159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E31B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1460"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_692_3274",
    x1: 19.8994,
    y1: 2.59913,
    x2: 3.57309,
    y2: 24.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E31B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1460"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiorbank);
export default __webpack_public_path__ + "static/media/Biorbank.fbcc5e4cc1c81e038fef4f588415c6c1.svg";
export { ForwardRef as ReactComponent };